// @flow

import React from 'react';
import { Link } from 'react-router';
import { Tracking } from 'web-core/src/tracking';

import conf from 'client/conf';
import Hero from 'client/components/account/hero';
import LinkButton from 'client/components/button/linkButton';
import Translate from 'client/components/translate';
import { WEB_CLICK_PROVISION_CODE } from 'routes/join/constants/tracking';

const PARTNER_PREFIX = 'partner.enterprise.contact';

type Props = {
  brand: string,
  siteConfigs: Object,
};

class ContactPage extends React.PureComponent<Props> {
  render() {
    const { brand, siteConfigs } = this.props;
    return (
      <div className="account-page text-center">
        <Hero brandName={brand} siteConfigs={siteConfigs} />
        <div className="center-col-small">
          <div className="margin">
            <img
              alt=""
              className="hero-image"
              src={`${conf.CONTENTFUL_SPACE_URL}/4Xl3fMbrIA4gOCIigGucCw/9c8b8c184672883071805bc2a396dcd7/Customer-Service.svg`} />
            <h4 className="semi-bold pad-bottom">
              <Translate path={`${PARTNER_PREFIX}.header`} />
            </h4>
            <p>
              <Translate path={`${PARTNER_PREFIX}.subheader`} />
            </p>
          </div>
          <LinkButton
            className="full margin-top-2 cta-button"
            href={`mailto:vip@stridebenefits.com?subject=${brand}%20partner%20code%20issue`}
            onClick={() =>
              Tracking.track(WEB_CLICK_PROVISION_CODE, { type: 'contact support', client: brand })
            }>
            <Translate path={`${PARTNER_PREFIX}.cta`} />
          </LinkButton>
          <p className="pad-y">
            <Translate path={`${PARTNER_PREFIX}.goBack`} />
            <Link to="/code">
              <Translate path={`${PARTNER_PREFIX}.goBackCta`} />
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export default ContactPage;
